import React from 'react'
import { useAccess } from 'contexts/access'
import { ProfileStatus, Description } from './s'
import Modal from 'modals/dialog'
import TiptapOutput from 'components/tiptap/output'

const ViewCompetenceProfileHero = ({ profile }) => {
    const { check } = useAccess()
    const manageAccess = check('competence:manage')

    const {
        symbol,
        name,
        description,
        public: isPublic = false
    } = profile ?? {}

    return (
        <Modal.Header
            symbol={{
                symbol,
                size: 56
            }}
            {...(!!manageAccess ?
                { kicker: <ProfileStatus status={isPublic ? 'public' : 'private'} /> }
                : null
            )}
            heading={name}
            headingClassName="serif"
            {...(!!description ?
                {
                    caption: (
                        <TiptapOutput
                            content={description}
                            element={Description} />
                    )
                }
                : null
            )} />
    )
}

export default ViewCompetenceProfileHero